import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var CalmColor = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    svgColor: "#fff",
    d: "M0 0h44v44H0z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M43.962 27.818a.302.302 0 0 0-.412-.118h-.002c-.318.178-1.377.53-1.712.651-1.255.205-2.793.16-3.55-1.674-.228-.553-.454-1.05-.844-1.573-.44-.591-1.886-1.295-3.234-.026-.35.32-.61.676-.834 1.03a8.16 8.16 0 0 0-.255.436l-.016-.058c-.12-.41-.5-1.928-2.086-2.175-.218-.018-1.1-.117-2.32 1.221-.427.465-.782.959-1.113 1.459v.002c-.059-.272-.13-.52-.2-.628-1.037-1.595-2.607-.322-3.284.154-1.516 1.066-2.219 2.498-3.143-.756-.119-.453-.214-.922-.287-1.398.92-1.564 2.796-6.324 1.72-9.515-.07-.201-.445-1.232-1.345-1.165-.13.012-1.156-.095-1.716 2.771-.525 2.771-.41 6.343-.282 7.527.014.123.041.365.09.682-.889 1.519-2.054 3.245-2.764 3.326-.923.105-.666-.746-1.23-2.635-.097-.245-.407-1.413-1.808-1.355-.685.029-1.41.207-2.4 1.29-1.607 1.757-5.273 4.401-7.895 2.74-.285-.221-1.702-1.379-1.18-4.849.155-.95.447-1.89.841-2.767.395-.877.882-1.698 1.44-2.425 2.694-3.308 5.027-3.694 5.488-3.674 1.18 0 1.487 1.528 1.487 1.514a.488.488 0 0 0 .972-.095c-.002-.013.002-.5-.2-.96-.185-.602-.718-1.16-1.027-1.367-1.48-1.03-4.822-.2-8.056 3.534a13.11 13.11 0 0 0-1.692 2.754 12.722 12.722 0 0 0-.982 3.206c-.873 6.151 2.872 7.13 3.51 7.25 3.282.382 5.7-1.404 6.842-2.5.413 2.054 2.466 2.079 3.366 1.152.23-.237.414-.527.557-.83.534 1.94 2.244 1.28 2.445 1.193.954-.357 1.95-1.684 2.655-2.797.448 1.527 1.313 3.162 2.974 2.987 1-.024 3.51-2.69 3.742-2.343.232.288.293.816.278 1.605-.015.788.611.828.895.75.439-.121.714-.985 1.173-1.736.36-.589.628-.923.985-1.315.18-.193.995-1.036 1.57-.75.575.286.634.874.673 1.2.044.326.045.672.058 1.05-.016 1.306.597 1.49.77 1.539 1.42.383 1.509-2.286 2.55-3.276.098-.101 1.008-1.04 1.528.492.75 2.77 3.06 3.806 6.171 2.266.577-.286.69-.398 1.005-.632a.302.302 0 0 0 .084-.39Zm-30.426-.562c-.62 1.276-1.987 1.199-1.968-.193.02-1.425 1.795-2.321 2.272-1.33.04.082.065.173.09.264-.082.262-.115.685-.394 1.259Zm7.64-12.002c.26.485.823 3.518-.712 6.833-.005-.105-.008-.211-.012-.317-.012-5.387.673-6.61.723-6.516Z",
    svgColor: "url(#b)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0,
    y1: 21.602,
    x2: 44,
    y2: 21.602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3478DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3BBEEC"
  }))));
});
CalmColor.displayName = 'CalmColor';
CalmColor.defaultProps = {
  'aria-label': 'CalmColor'
};
export default CalmColor;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Logo/CalmColor.js
// module id = 3568
// module chunks = 11